export const menu = [
  {
    id: 1,
    value: '/profile/history',
    label: 'labels.orders',
  },
  // {
  //   id: 2,
  //   value: '/profile/loyalty',
  //   label: 'labels.bonuses',
  // },
  // {
  //   id: 2,
  //   value: '/profile/personal',
  //   label: 'Мой профиль',
  // },
];

export const footerMenu = [
  {
    to: '/#about',
    label: 'labels.about',
  },
  {
    to: '/drugstores',
    label: 'labels.network_of_drugstores',
  },
  {
    to: '/promotions',
    label: 'labels.promotions',
  },
  {
    to: '/loyalty',
    label: 'labels.Loyalty_program',
  },
];
